/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.StrategicGoalMilestone = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The StrategicGoalMilestone model module.
   * @module model/StrategicGoalMilestone
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>StrategicGoalMilestone</code>.
   * @alias module:model/StrategicGoalMilestone
   * @class
   */
  var exports = function() {
    var _this = this;



































  };

  /**
   * Constructs a <code>StrategicGoalMilestone</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StrategicGoalMilestone} obj Optional instance to populate.
   * @return {module:model/StrategicGoalMilestone} The populated <code>StrategicGoalMilestone</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('AchievedByDate')) {
        obj['AchievedByDate'] = ApiClient.convertToType(data['AchievedByDate'], 'Date');
      }
      if (data.hasOwnProperty('GoalID')) {
        obj['GoalID'] = ApiClient.convertToType(data['GoalID'], 'Integer');
      }
      if (data.hasOwnProperty('Description')) {
        obj['Description'] = ApiClient.convertToType(data['Description'], 'String');
      }
      if (data.hasOwnProperty('OwnerUserID')) {
        obj['OwnerUserID'] = ApiClient.convertToType(data['OwnerUserID'], 'Integer');
      }
      if (data.hasOwnProperty('StatusID')) {
        obj['StatusID'] = ApiClient.convertToType(data['StatusID'], 'Integer');
      }
      if (data.hasOwnProperty('StartDate')) {
        obj['StartDate'] = ApiClient.convertToType(data['StartDate'], 'Date');
      }
      if (data.hasOwnProperty('ArchivedDate')) {
        obj['ArchivedDate'] = ApiClient.convertToType(data['ArchivedDate'], 'Date');
      }
      if (data.hasOwnProperty('FinalStatusID')) {
        obj['FinalStatusID'] = ApiClient.convertToType(data['FinalStatusID'], 'Integer');
      }
      if (data.hasOwnProperty('SuccessCalculationCurrentPercentage')) {
        obj['SuccessCalculationCurrentPercentage'] = ApiClient.convertToType(data['SuccessCalculationCurrentPercentage'], 'Number');
      }
      if (data.hasOwnProperty('SuccessCalculationStatusUpdateID')) {
        obj['SuccessCalculationStatusUpdateID'] = ApiClient.convertToType(data['SuccessCalculationStatusUpdateID'], 'Integer');
      }
      if (data.hasOwnProperty('AskResponsiblePersonToChangeThePlan')) {
        obj['AskResponsiblePersonToChangeThePlan'] = ApiClient.convertToType(data['AskResponsiblePersonToChangeThePlan'], 'Boolean');
      }
      if (data.hasOwnProperty('ReasonOfClosing')) {
        obj['ReasonOfClosing'] = ApiClient.convertToType(data['ReasonOfClosing'], 'String');
      }
      if (data.hasOwnProperty('OriginalStartDate')) {
        obj['OriginalStartDate'] = ApiClient.convertToType(data['OriginalStartDate'], 'Date');
      }
      if (data.hasOwnProperty('OriginalAchievedByDate')) {
        obj['OriginalAchievedByDate'] = ApiClient.convertToType(data['OriginalAchievedByDate'], 'Date');
      }
      if (data.hasOwnProperty('CustomLabel')) {
        obj['CustomLabel'] = ApiClient.convertToType(data['CustomLabel'], 'String');
      }
      if (data.hasOwnProperty('CompanyFunctionID')) {
        obj['CompanyFunctionID'] = ApiClient.convertToType(data['CompanyFunctionID'], 'Integer');
      }
      if (data.hasOwnProperty('CompanyVirtualTeamID')) {
        obj['CompanyVirtualTeamID'] = ApiClient.convertToType(data['CompanyVirtualTeamID'], 'Integer');
      }
      if (data.hasOwnProperty('FatherID')) {
        obj['FatherID'] = ApiClient.convertToType(data['FatherID'], 'Integer');
      }
      if (data.hasOwnProperty('ParentProgramID')) {
        obj['ParentProgramID'] = ApiClient.convertToType(data['ParentProgramID'], 'Integer');
      }
      if (data.hasOwnProperty('CompletedDate')) {
        obj['CompletedDate'] = ApiClient.convertToType(data['CompletedDate'], 'Date');
      }
      if (data.hasOwnProperty('Updated')) {
        obj['Updated'] = ApiClient.convertToType(data['Updated'], 'Date');
      }
      if (data.hasOwnProperty('UpdatedBy')) {
        obj['UpdatedBy'] = ApiClient.convertToType(data['UpdatedBy'], 'Integer');
      }
      if (data.hasOwnProperty('ProgressCalculationMethodID')) {
        obj['ProgressCalculationMethodID'] = ApiClient.convertToType(data['ProgressCalculationMethodID'], 'Integer');
      }
      if (data.hasOwnProperty('ProgressCalculationSourceID')) {
        obj['ProgressCalculationSourceID'] = ApiClient.convertToType(data['ProgressCalculationSourceID'], 'Integer');
      }
      if (data.hasOwnProperty('ConnectedToMilestoneID')) {
        obj['ConnectedToMilestoneID'] = ApiClient.convertToType(data['ConnectedToMilestoneID'], 'Integer');
      }
      if (data.hasOwnProperty('ConnectedToProgramID')) {
        obj['ConnectedToProgramID'] = ApiClient.convertToType(data['ConnectedToProgramID'], 'Integer');
      }
      if (data.hasOwnProperty('ConnectableAggregationTarget')) {
        obj['ConnectableAggregationTarget'] = ApiClient.convertToType(data['ConnectableAggregationTarget'], 'Boolean');
      }
      if (data.hasOwnProperty('SecondaryStatusUpdateTypeID')) {
        obj['SecondaryStatusUpdateTypeID'] = ApiClient.convertToType(data['SecondaryStatusUpdateTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('PerformancePerspectiveGroupID')) {
        obj['PerformancePerspectiveGroupID'] = ApiClient.convertToType(data['PerformancePerspectiveGroupID'], 'Integer');
      }
      if (data.hasOwnProperty('CreatorID')) {
        obj['CreatorID'] = ApiClient.convertToType(data['CreatorID'], 'Integer');
      }
      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('Sort')) {
        obj['Sort'] = ApiClient.convertToType(data['Sort'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Date} AchievedByDate
   */
  exports.prototype['AchievedByDate'] = undefined;
  /**
   * @member {Integer} GoalID
   */
  exports.prototype['GoalID'] = undefined;
  /**
   * @member {String} Description
   * @default ''
   */
  exports.prototype['Description'] = '';
  /**
   * @member {Integer} OwnerUserID
   */
  exports.prototype['OwnerUserID'] = undefined;
  /**
   * @member {Integer} StatusID
   * @default 0
   */
  exports.prototype['StatusID'] = 0;
  /**
   * @member {Date} StartDate
   */
  exports.prototype['StartDate'] = undefined;
  /**
   * @member {Date} ArchivedDate
   */
  exports.prototype['ArchivedDate'] = undefined;
  /**
   * @member {Integer} FinalStatusID
   */
  exports.prototype['FinalStatusID'] = undefined;
  /**
   * @member {Number} SuccessCalculationCurrentPercentage
   */
  exports.prototype['SuccessCalculationCurrentPercentage'] = undefined;
  /**
   * @member {Integer} SuccessCalculationStatusUpdateID
   */
  exports.prototype['SuccessCalculationStatusUpdateID'] = undefined;
  /**
   * @member {Boolean} AskResponsiblePersonToChangeThePlan
   * @default false
   */
  exports.prototype['AskResponsiblePersonToChangeThePlan'] = false;
  /**
   * @member {String} ReasonOfClosing
   * @default ''
   */
  exports.prototype['ReasonOfClosing'] = '';
  /**
   * @member {Date} OriginalStartDate
   */
  exports.prototype['OriginalStartDate'] = undefined;
  /**
   * @member {Date} OriginalAchievedByDate
   */
  exports.prototype['OriginalAchievedByDate'] = undefined;
  /**
   * @member {String} CustomLabel
   * @default ''
   */
  exports.prototype['CustomLabel'] = '';
  /**
   * @member {Integer} CompanyFunctionID
   */
  exports.prototype['CompanyFunctionID'] = undefined;
  /**
   * @member {Integer} CompanyVirtualTeamID
   */
  exports.prototype['CompanyVirtualTeamID'] = undefined;
  /**
   * @member {Integer} FatherID
   */
  exports.prototype['FatherID'] = undefined;
  /**
   * @member {Integer} ParentProgramID
   */
  exports.prototype['ParentProgramID'] = undefined;
  /**
   * @member {Date} CompletedDate
   */
  exports.prototype['CompletedDate'] = undefined;
  /**
   * @member {Date} Updated
   */
  exports.prototype['Updated'] = undefined;
  /**
   * @member {Integer} UpdatedBy
   */
  exports.prototype['UpdatedBy'] = undefined;
  /**
   * @member {Integer} ProgressCalculationMethodID
   * @default 0
   */
  exports.prototype['ProgressCalculationMethodID'] = 0;
  /**
   * @member {Integer} ProgressCalculationSourceID
   */
  exports.prototype['ProgressCalculationSourceID'] = undefined;
  /**
   * @member {Integer} ConnectedToMilestoneID
   */
  exports.prototype['ConnectedToMilestoneID'] = undefined;
  /**
   * @member {Integer} ConnectedToProgramID
   */
  exports.prototype['ConnectedToProgramID'] = undefined;
  /**
   * @member {Boolean} ConnectableAggregationTarget
   * @default false
   */
  exports.prototype['ConnectableAggregationTarget'] = false;
  /**
   * @member {Integer} SecondaryStatusUpdateTypeID
   * @default 0
   */
  exports.prototype['SecondaryStatusUpdateTypeID'] = 0;
  /**
   * @member {Integer} PerformancePerspectiveGroupID
   */
  exports.prototype['PerformancePerspectiveGroupID'] = undefined;
  /**
   * @member {Integer} CreatorID
   * @default 0
   */
  exports.prototype['CreatorID'] = 0;
  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {Integer} Sort
   * @default 0
   */
  exports.prototype['Sort'] = 0;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


